module.exports = __webpack_public_path__ + "static/media/8x10no1.5f2a002b.jpg";